import React from 'react';

import { LoanBanner } from '..';

export const Settled: React.FC = () => (
  <LoanBanner>
    <span>This loan has been settled.</span>
  </LoanBanner>
);
